import {
    DASHBOARD_GET_ACTION, 
    DASHBOARD_GET_CLOCKED_IN_EMPLOYEES_ACTION, 
    DASHBOARD_GET_POPULAR_JOB_SITE_ACTION,
    DASHBOARD_GET_FEES_COLLECTED_ACTION,
    DASHBOARD_GET_EARNINGS_ACTION,
    DASHBOARD_GET_TICKETS_ACTION,
    DASHBOARD_GET_TOTAL_JOB_SITES_ACTION,
    DASHBOARD_GET_MOST_PROFITABLE_COMPANY_ACTION,
    DASHBOARD_GET_LEAST_PROFITABLE_COMPANY_ACTION
} from "../../constants/actions"

const initialState = {
    list: {},
    clockedInEmployees: {
        status: false,
        data: {
            count: 0,
            employees: []
        }
    },
    popularJobSite: {
        status: false,
        data: {
            job_site_name: '',
            tickets_count: 0
        }
    },
    feesCollected: {
        status: false,
        data: {}
    },
    earnings: {
        status: false,
        data: {}
    },
    tickets: {
        status: false,
        data: {}
    },
    totalJobSites: {
        status: false,
        data: {}
    },
    mostProfitableCompany: {
        status: false,
        data: {}
    },
    leastProfitableCompany: {
        status: false,
        data: {}
    }
}

const dashboardReducer = (state = initialState, action) => {

    switch (action.type) {

        case DASHBOARD_GET_ACTION:
            return {
                ...state,
                list: action.list
            }
        case DASHBOARD_GET_CLOCKED_IN_EMPLOYEES_ACTION:
            return {
                ...state,
                clockedInEmployees: action.payload
            }
        case DASHBOARD_GET_POPULAR_JOB_SITE_ACTION:
            return {
                ...state,
                popularJobSite: action.payload
            }
        case DASHBOARD_GET_FEES_COLLECTED_ACTION:
            return {
                ...state,
                feesCollected: action.payload
            }
        case DASHBOARD_GET_EARNINGS_ACTION:
            return {
                ...state,
                earnings: action.payload
            }
        case DASHBOARD_GET_TICKETS_ACTION:
            return {
                ...state,
                tickets: action.payload
            }
        case DASHBOARD_GET_TOTAL_JOB_SITES_ACTION:
            return {
                ...state,
                totalJobSites: action.payload
            }
        case DASHBOARD_GET_MOST_PROFITABLE_COMPANY_ACTION:
            return {
                ...state,
                mostProfitableCompany: action.payload
            }
        case DASHBOARD_GET_LEAST_PROFITABLE_COMPANY_ACTION:
            return {
                ...state,
                leastProfitableCompany: action.payload
            }
        default: return state
    }
}

export default dashboardReducer